import '../scss/app.scss';

/* utils */
import { indexPage } from './utils/indexPage';
import { primaryDir } from './utils/documentLocation';
import { getNavHeight, getFooterHeight } from './utils/getCSSProperties';
import { addFadeIn } from './utils/utils';
import { retrieveFromSessionStorage } from './utils/utilsStorage';

/* components */
import { navigation } from './components/navigation';
import { activeNavigation } from './utils/activeNavigation';
import { wpReset } from './components/wpReset';
import { fetchIndexPage } from './components/fetchIndexPage';
import { fetchNavigation } from './components/fetchNavigation';
import { fetchNavigationPrivate } from './components/fetchNavigationPrivate';
import { fetchPageOnLoad } from './components/fetchPageOnLoad';
import { logout } from './components/logout';
import { cursor } from './utils/cursor';
import { resetResponsive } from './utils/resetResponsive';

/* tags
* tagId 5 = 'public'
* tagId 6 = 'private'
*/

document.addEventListener('DOMContentLoaded', () => {
    console.log('Velkommen til skifterhænder.com');
    addFadeIn();
    navigation();
    activeNavigation();
    getNavHeight();
    getFooterHeight();
    indexPage();
    fetchPageOnLoad();
    logout();
    cursor();
    wpReset();

    // fetch index page
    if (!primaryDir || primaryDir === 'index') {
        fetchIndexPage();
    }
    
    // public pages
    fetchNavigation(5);
    
    // private pages (add condition based on pathname)
    const privatePagesData = retrieveFromSessionStorage('privatePages');
    if (privatePagesData || primaryDir === 'art' ) {
        fetchNavigationPrivate(6);
    }
});

window.addEventListener('resize', () => {
    getNavHeight();
    getFooterHeight();
    resetResponsive();
});

screen.orientation.addEventListener('change', () => {
    getNavHeight();
    getFooterHeight();
});